import React, { useEffect, useRef, useContext, useState, KeyboardEvent } from "react";

import { callApi, serializeObject } from "bodycodi/cmap/app/js/common";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { observerType } from "bodycodi/cmap/app/components/common/useObserver";
import MemberList from "bodycodi/cmap/app/components/common/MemberList";
import icon_search from "bodycodi/cmap/app/svg/icon_search.svg";
import remove from "bodycodi/cmap/app/img/remove.png";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { Members } from "bodycodi/cmap/app/type";

export interface State extends observerType {
  isDone: boolean;
  isScrollEnd: boolean;
  isBan: boolean;
}

interface MemberSearchPopWrap {
  from: string;
  onClickMember: any;
  chooseMemberList: any;
}

const MemberSearchPopWrap = ({ from, onClickMember, chooseMemberList }: MemberSearchPopWrap) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const { dispatch } = useContext(DispatchContext);
  const { state: stateContx } = useContext(StateContext);
  const input = useRef<HTMLInputElement>(null);
  const inputWrap = useRef<HTMLDivElement>(null);
  const [reomve, setRemove] = useState<boolean>(false);
  const [members, setMembers] = useState<Members>({
    appointmentMemberTotalCount: 0,
    chargeMemberTotalCount: 0,
    entranceMemberTotalCount: 0,
    memberList: [],
  });
  const [state, setState] = useState<State>({
    pageNo: 0,
    listSize: 10,
    loading: false,
    first: true,
    isDone: false,
    isScrollEnd: false,
    isBan: true,
  });
  const { pageNo, listSize } = state;

  useEffect(() => {
    if (!stateContx.memberSearchPop) {
      setRemove(false);
      setMembers({
        appointmentMemberTotalCount: 0,
        chargeMemberTotalCount: 0,
        entranceMemberTotalCount: 0,
        memberList: [],
      });
      setState((previousValue: State) => ({
        ...previousValue,
        pageNo: 0,
        loading: false,
        isDone: false,
        isScrollEnd: false,
      }));
      const input1 = input.current!;
      input1.value = "";
    }
    return;
  }, [stateContx.memberSearchPop]);

  const fetchMembers = (type: string) => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
      isDone: type === "fetch" ? false : previousValue.isDone,
      isScrollEnd: type === "fetch" ? false : previousValue.isScrollEnd,
    }));
    const data: any = serializeObject({ element: inputWrap.current });
    callApi(
      "/members",
      {
        seqPartner: seqPartner,
        seqPartnerBranch: seqPartnerBranch,
        seqPartnerCoach: seqPartnerCoach,
        keyword: data.name,
        pageNo: type === "fetch" ? 0 : pageNo,
        rowAmt: listSize,
      },
      "GET"
    )
      .then((res) => {
        console.log(res);
        if (type === "add") {
          setMembers((previousValue: Members) => ({
            ...previousValue,
            memberList: previousValue.memberList.concat(res.memberList),
          }));
        } else {
          setMembers(res);
        }
        if (res.memberList.length < listSize) {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: 0,
            isDone: true,
            isScrollEnd: true,
          }));
        } else {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: previousValue.pageNo + previousValue.listSize,
            isDone: false,
          }));
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setState((previousValue: State) => ({
          ...previousValue,
          loading: false,
          isBan: false,
        }));
      });
  };

  const openMemberSearch = (open: boolean) => {
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_SEARCH_POP", open: { memberSearchPop: open } });
  };

  const onKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    const keyCode = e.which ? e.which : e.keyCode;
    if (keyCode === 13) {
      setMembers((previousValue: Members) => ({
        ...previousValue,
        memberList: [],
      }));
      fetchMembers("fetch");
    }
  };

  const onClickRemove = () => {
    openMemberSearch(false);
    setRemove(false);
    setState((previousValue: State) => ({
      ...previousValue,
      isBan: true,
    }));
  };

  const onFocus = () => {
    openMemberSearch(true);
    setRemove(true);
  };

  const onBlur = () => {
    if (!input?.current?.value) {
      openMemberSearch(false);
      setState((previousValue: State) => ({
        ...previousValue,
        isBan: true,
      }));
    }
  };

  return (
    <div className="member-mngt-condition-wrap">
      <div className="member-mngt-search" ref={inputWrap}>
        <img className="icon" src={icon_search} />
        <input
          name="name"
          placeholder="회원님 이름, 전화번호 뒤 4자리로 검색"
          onKeyPress={onKeyUp}
          onFocus={onFocus}
          onBlur={onBlur}
          ref={input}
        />
        {reomve && <img className="remove" src={remove} onClick={onClickRemove} />}
      </div>
      <div className={"member-search-disabled" + (stateContx.memberSearchPop ? " open" : " close")}>
        {stateContx.memberSearchPop && (
          <div className="member-mngt-wrap">
            <MemberList
              memberList={members.memberList}
              scrollEnd={state.isScrollEnd}
              loading={state.loading}
              listSize={state.listSize}
              isDone={state.isDone}
              isBan={state.isBan}
              fetchMembers={fetchMembers}
              from={from}
              onClickMember={onClickMember}
              chooseMemberList={chooseMemberList}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MemberSearchPopWrap;
